import { render, staticRenderFns } from "./yijian.vue?vue&type=template&id=1ffd6cb7&"
import script from "./yijian.vue?vue&type=script&lang=js&"
export * from "./yijian.vue?vue&type=script&lang=js&"
import style0 from "./yijian.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports